import { LOCATION_CHANGE } from 'connected-react-router';

import {
  ADD_BLACKLISTS_START,
  ADD_BLACKLISTS_SUCCESS,
  ADD_BLACKLISTS_ERROR,
  SHOW_BLACKLIST_START,
  SHOW_BLACKLIST_SUCCESS,
  SHOW_BLACKLIST_ERROR,
  CREATE_BLACKLIST_START,
  CREATE_BLACKLIST_SUCCESS,
  CREATE_BLACKLIST_ERROR,
  UPDATE_BLACKLIST_START,
  UPDATE_BLACKLIST_SUCCESS,
  UPDATE_BLACKLIST_ERROR,
} from '../constants/Blacklist';

const defaultState = {
  path: null,

  item: {},
  itemLoading: false,
  itemFetched: false,

  items: [],
  itemsFetched: false,
  itemsLoading: false,
  meta: { page: 1, pageSize: 10 },

  errorMessage: null,
};

export default function BlacklistReducer(
  state = defaultState,
  { type, payload, items, meta, errorMessage, item }
) {
  switch (type) {
    case LOCATION_CHANGE:
      return state.path === payload.pathname
        ? { ...state }
        : { ...defaultState, path: payload.pathname };

    case ADD_BLACKLISTS_START:
      return {
        ...state,
        itemsLoading: true,
        itemsFetched: false,
      };

    case ADD_BLACKLISTS_SUCCESS:
      return {
        ...state,
        itemsLoading: false,
        errorMessage: null,
        itemsFetched: true,
        items,
        meta,
      };

    case ADD_BLACKLISTS_ERROR:
      return {
        ...state,
        itemsLoading: false,
        itemsFetched: false,
        errorMessage,
      };

    case SHOW_BLACKLIST_START:
      return {
        ...state,
        itemLoading: true,
        itemFetched: false,
      };

    case SHOW_BLACKLIST_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        itemFetched: true,
        errorMessage: null,
        item,
      };

    case SHOW_BLACKLIST_ERROR:
      return {
        ...state,
        itemLoading: false,
        itemFetched: false,
        errorMessage,
      };

    case CREATE_BLACKLIST_START:
      return {
        ...state,
        itemLoading: true,
      };

    case CREATE_BLACKLIST_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case CREATE_BLACKLIST_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    case UPDATE_BLACKLIST_START:
      return {
        ...state,
        itemLoading: true,
      };

    case UPDATE_BLACKLIST_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case UPDATE_BLACKLIST_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    default:
      return state;
  }
}
